import { Spacer } from '@loomhq/lens';
import classnames from 'classnames';
import React from 'react';
import { useSelector } from 'react-redux';

import { selectCtaEnabled } from 'selectors/shareVideo';
import { selectHasStarted, selectShowCta } from 'selectors/videoPlayer';

import EmbedActionButtons from './action-buttons';
import CtaButton from './cta-button-rework';
import EmbedTitleAuthor from './embed-title-author';

import styles from './styles.module.less';

const EmbedTopBar = () => {
  const hasStarted = useSelector(selectHasStarted);
  const showCta = useSelector(selectShowCta);
  const ctaEnabled = useSelector(selectCtaEnabled);

  return (
    <div className={classnames(styles.embedTopSection, 'theme-dark')}>
      <div className={styles.titleAuthorSection}>
        {!hasStarted && <EmbedTitleAuthor />}
      </div>
      <div className={styles.buttonSection}>
        {ctaEnabled && showCta && <CtaButton />}
        <Spacer left="small" />
        <EmbedActionButtons showBackdrop={hasStarted} />
      </div>
    </div>
  );
};

export default EmbedTopBar;
